/**
 * Local mirror of an org's current billing plan limits (see entitlements_cache
 * table in the customer DB schema). Written only by the server -- never by
 * client code.
 */
export interface EntitlementsCache {
  id: string;
  plan_id: string;
  plan_name: string;
  asset_limit: number; // -1 sentinel = unlimited
  custom_form_limit: number; // -1 sentinel = unlimited
  subscription_status: string;
  updated_at: number;
  updated_by: string;
}

export const UNLIMITED = -1;
